<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <router-view></router-view>
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Fleet Tool Management | FMS",
      meta: [
        {
          name: "description",
          content:
            "To Manage your Fleet inventory, our system provides general overview with dashboard reports, your fleet's estimated payoff amounts by calculating from information you provided to us and comparing this payoff amount with current market value.",
        },
        {
          property: "og:title",
          content: "Fleet Tool Management | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Gotham";
  src: url("/assets/Gotham-Medium.woff2") format("woff2"),
    url("/assets/Gotham-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
</style>